import { openDB } from 'idb';

const DB_NAME = 'daksha_cim_db';
const STORE_NAME = 'temp_customers';
const DB_VERSION = 1;

export const initDB = async () => {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
            }
        },
    });
};

export const saveChunk = async (chunk) => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await Promise.all(chunk.map(item => store.add(item)));
    await tx.done;
};

export const getAllRecords = async () => {
    const db = await initDB();
    return db.getAll(STORE_NAME);
};

export const clearDB = async () => {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    await tx.objectStore(STORE_NAME).clear();
    await tx.done;
};

export const countRecords = async () => {
    const db = await initDB();
    return db.count(STORE_NAME);
};
